var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"headline"},[_vm._v("Reports")]),_c('v-container',[_c('sites'),_c('franchises',{staticClass:"mt-3"}),_c('perf',{staticClass:"mt-3"}),_c('jobs',{staticClass:"mt-3"}),_c('material',{staticClass:"mt-3"}),_c('material-history',{staticClass:"mt-3"}),_c('snags',{staticClass:"mt-3"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad66f082","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports.vue
// module id = 532
// module chunks = 0